import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Document } from '@lockton-apps/shared/interfaces';
import { AvatarModule } from '@lockton-apps/shared/ui/lui';
import { DocumentIconPipe } from '@lockton-apps/shared/ui/pipes';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'la-confirm-delete-document',
    imports: [
        CommonModule,
        DocumentIconPipe,
        LetDirective,
        AvatarModule,
        MatIconModule,
    ],
    template: `
    <div i18n>
      You are about to delete the folder
      <strong>{{ name }}</strong>
      and all of its contents ({{ documents.length }} item/s).
    </div>
    <div class="mt-1" *ngIf="documents.length > 0">
      <div>
        <ng-container i18n>
          The following documents will also be deleted:
        </ng-container>
        <ul class="row g-1 mt-2">
          <li
            class="col-6 d-flex align-items-center"
            *ngFor="let document of documents"
          >
            <lui-avatar
              *ngrxLet="document.fileType | documentIcon as icon"
              [color]="icon.color"
              [size]="32"
              class="me-_5"
            >
              <mat-icon [svgIcon]="icon.icon"></mat-icon>
            </lui-avatar>
            {{ document.fileName }}</li
          >
        </ul>
      </div>
    </div>
  `
})
export class ConfirmDeleteFolderDialogComponent {
  @Input() name!: string;
  @Input() documents!: Document[];
}
